import type { FaireProductEntity } from "../../entity_types/product";

export const p_vd6znds2ja: FaireProductEntity = {
  token: "p_vd6znds2ja",
  type: "product",
  name: "Custom Youth T Shirt, Personalized Kids Tshirt",
  brandToken: "b_n9fwmzzqs5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/347b3bcecaee129b1819f523ea0264b5bee94b9ac3df411426dcd9b4a03bde53.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/024540774a357c00b590c82d96151e6ae07dc2fb96125894d3be589d475ab404.jpeg",
    "https://cdn.faire.com/fastly/289565513574fd7dbfa87d7ec10b2b78421c390df0285453ddd21f0e2fc56f16.png",
    "https://cdn.faire.com/fastly/acbb985191addffa5543fcd1174e04233a71ccfa368db64d137ffb4deed94f48.jpeg",
    "https://cdn.faire.com/fastly/dd233de42f4aef276d19a8534ef64907510bb8df46cefd20201cf767f7507ad5.jpeg",
    "https://cdn.faire.com/fastly/b09c5cee467666c83f6ec79bf7def3f6f0af850f80c83d2ddf187dc7286f3efa.jpeg",
    "https://cdn.faire.com/fastly/a1958ac643279ae130f1ae5cf464b91eb288c8624a64a45a01c5a7361a53c9ad.jpeg",
    "https://cdn.faire.com/fastly/ca79012b183f6f448c414b6e82ca38e10db5e31d98ac55117c8d5e81fef92dae.jpeg",
  ],
  priceDollars: 17.32,
  description:
    "Custom Youth Jersey T Shirt, Custom Text T-Shirt, Personalized Tshirt\n\n\nCustom  Shirt, Custom Text T-Shirt, Personalized Text\n\n  👍We will send you a proof/mockup to approve, and make any adjustments, before printing. \n\n👌Keep in mind that we will not print anything copyrighted or trademarked. \n** Youth Jersey\n4.2 oz./yd² (US) 7 oz./L yd (CA), 100% Airlume combed and ring-spun cotton, 32 singles\nPre-shrunk\nRetail fit Unisex sizing Side seams Tear away label\n\n👕 Unmatched Softness: Dive into a world of unparalleled comfort with our supremely soft fabric. Each touch is a gentle embrace, ensuring you feel relaxed all day long.\n\n🎨 Vibrant Hues: Make a statement with our extensive palette of vibrant colors. From subtle shades to bold pops, express yourself in every hue imaginable.\n",
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:43.879Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
